import { Injectable } from '@angular/core';
import { IntercomUserHash } from '@services/user.service';
declare let Intercom: any;

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  constructor() {}

  initializeIntercom({
    roleData,
    instanceData,
    intercomUserHash,
  }: {
    roleData: any;
    instanceData: any;
    intercomUserHash: IntercomUserHash | null;
  }) {
    try {
      if (!intercomUserHash?.intercom_user_jwt || !intercomUserHash?.user_id) {
        return;
      }
      Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: 'mdla6l5j',
        user_id: intercomUserHash.user_id,
        email: intercomUserHash.email,
        intercom_user_jwt: intercomUserHash.intercom_user_jwt,
        name: `${roleData?.data?.first_name} ${roleData?.data?.last_name}`,
        user_role: roleData.role,
        instance_name: instanceData.name,
        institution_name: instanceData.name,
        institution_id: instanceData.id,
        scaffold_type: instanceData.scaffoldType,
        company: instanceData.name,
      });
    } catch (error) {}
  }

  updateIntercom() {
    try {
      Intercom('update');
    } catch (error) {}
  }

  shutdownIntercom() {
    try {
      Intercom('shutdown');
    } catch (error) {}
  }

  trackEvent(event, metadata = {}) {
    try {
      Intercom('trackEvent', event, metadata);
    } catch (error) {}
  }

  startTicket() {
    try {
      Intercom('showSpace', 'home');
      setTimeout(() => {
        Intercom('showNewMessage', 'Ask A question');
      }, 2000);
    } catch (error) {
      console.error('Error showing new message:', error);
    }
  }
}
